import React from 'react'

import { Skeleton, Typography } from '@mui/material'

// Mirrors `renderStatTileValue`'s two-line structure (value line + caption line)
// so a tile's height doesn't shift when the real content swaps in.
export const STAT_TILE_SKELETON = (
  <>
    <Skeleton variant="text" width="55%" sx={{ fontSize: '1.65rem' }} />
    <Skeleton variant="text" width="80%" sx={{ fontSize: '0.75rem', mt: 0.25 }} />
  </>
)

/**
 * Shared body of a `StatValueCard` tile across the analytics detail pages: a big
 * accented value on its own line, then one short caption line in `text.secondary`
 * below it (multiple fragments joined with a middle dot).
 *
 * `value` takes a node, not just a string, so a tile can put an inline adornment
 * (the change tiles' direction arrow) on the same line as the number without a
 * second copy of the tile body.
 */
export function renderStatTileValue(accent: string, value: React.ReactNode, ...captionFragments: (string | undefined)[]): React.ReactNode {
  const caption = captionFragments.filter((text): text is string => Boolean(text)).join(' · ')
  return (
    <>
      <Typography sx={{ fontWeight: 700, fontSize: { xs: '1.5rem', md: '1.65rem' }, lineHeight: 1.05, color: accent, fontVariantNumeric: 'tabular-nums' }}>
        {value}
      </Typography>
      {caption ? (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25, lineHeight: 1.2 }}>
          {caption}
        </Typography>
      ) : null}
    </>
  )
}
